// frontend/src/hooks/useVehiclePools.ts — the vehicle pools as a picker's small
// list (ADR-080 §3): the project's attached pools the viewer may see, asked
// whole when a picker opens (or for the names of a pool already chosen), a
// minute fresh. A disabled pool is an inactive row — a filter offers it once
// typed (ADR-080 §5). The route exists only while the vehicles module is on; a
// host asks the source only then. The fleet pages (future work) grow this file.

import type { VehiclePoolsResponse } from '@ems-app/schemas/vehicles/pools';
import { apiClient } from '../lib/apiClient.js';
import type { SmallSource } from './useOptions.js';

export const vehiclePoolsKeys = {
  /** The pools one may see — the picker's whole read. */
  all: (projectId: string) => ['vehicle-pools', projectId] as const,
};

async function fetchVehiclePools(projectId: string, signal?: AbortSignal): Promise<VehiclePoolsResponse> {
  const r = await apiClient.get<VehiclePoolsResponse>(`/projects/${projectId}/vehicle-pools`, { signal });
  return r.data;
}

/** The pools as a picker's source (the small kind): the name alone. */
export function vehiclePoolsSource(projectId: string): SmallSource<VehiclePoolsResponse> {
  return {
    kind: 'small',
    queryKey: vehiclePoolsKeys.all(projectId),
    fetch: (signal) => fetchVehiclePools(projectId, signal),
    rows: (r) => r.items.map((p) => ({ id: p.id, label: p.name, pickable: true, inactive: p.is_disabled, group: null })),
  };
}
